// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcb_a bhl_ke","ListItemIcon--empty":"bcb_b bhl_fl"};